import React from 'react';

import StoryblokBloks from './storyblok-bloks';

function StoryblokPage(props) {
  return <StoryblokBloks {...props} />;
}

export default StoryblokPage;
